interface props {
  large?: boolean;
}
const SvgLikeOutlined: React.FC<props> = ({ large }) => {
  return (
    <svg
      style={large ? { transform: "scale(1.5)" } : {}}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24440_1994)">
        <path
          d="M5.6416 1.52537C5.58284 1.52712 5.52531 1.54266 5.47365 1.57073C5.422 1.59881 5.37767 1.63863 5.34424 1.68699C5.34424 1.68699 4.9501 2.25883 4.47363 2.90818C3.99717 3.55754 3.41677 4.29996 3.14111 4.56053C2.61923 5.05398 2.25 5.72536 2.25 6.48533V8.12498C2.25 9.70838 3.5416 11 5.125 11H7.45996C8.40207 11 9.20249 10.2934 9.32031 9.35887L9.45068 8.42674L9.66064 6.92674L9.74658 6.31541C9.86151 5.49492 9.21309 4.74998 8.38477 4.74998H6.26709C6.44017 4.32135 6.56742 3.93329 6.65625 3.49656C6.65641 3.49656 6.65658 3.49656 6.65674 3.49656C6.70871 3.24072 6.75244 3.04 6.75244 2.82664C6.75244 2.31254 6.48992 1.94342 6.23535 1.75877C5.98077 1.57413 5.71631 1.53026 5.71631 1.53026C5.69163 1.52614 5.6666 1.5245 5.6416 1.52537ZM5.78467 2.36131C5.79 2.36493 5.78953 2.36228 5.79492 2.36619C5.90261 2.4443 6.00244 2.53824 6.00244 2.82664C6.00244 2.92029 5.97291 3.0935 5.92139 3.34715C5.8293 3.79987 5.72479 4.15264 5.53125 4.60447C5.53125 4.60464 5.53125 4.6048 5.53125 4.60496C5.44999 4.79529 5.45806 5.01016 5.55762 5.18797C5.65717 5.36577 5.86962 5.49998 6.09375 5.49998H8.38477C8.77094 5.49998 9.05699 5.8289 9.00342 6.21141L8.91797 6.82322L8.70801 8.32322L8.57715 9.25877C8.57681 9.26072 8.57648 9.26267 8.57617 9.26463C8.50529 9.83077 8.03032 10.25 7.45996 10.25H5.125C3.9469 10.25 3 9.30308 3 8.12498V6.48533C3 5.96831 3.25113 5.4885 3.65625 5.10545C4.04734 4.73577 4.59416 4.01161 5.07812 3.35203C5.46503 2.82473 5.66669 2.53109 5.78467 2.36131Z"
          className="fill-current"
        />
      </g>
      <defs>
        <clipPath id="clip0_24440_1994">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgLikeOutlined;
